export default "__VITE_ASSET__DlJUSfW5__"